import Config from 'arbitrip-common/client/utils/Config';
import { addUtmDataToUrl } from 'arbitrip-common/client/utils/UtmUtils';
import ApiURLs from '@/utils/ApiURLs';

const RESULTS_REF_URL_PARAMS = [
    'place_id',
    'hotel_id',
    'check_in',
    'check_out',
    'guests',
    'children_ages',
    'rooms',
    'search_token',
];

export function buildLoginUrl({ filterResultsRefUrl = false } = {}) {
    const baseLoginUrl = Config.is_letstay ? ApiURLs.LETSTAY_LOGIN : Config.prod ? '/login' : ApiURLs.LOGIN;
    const refUrl = new URL(window.location.href);

    if (filterResultsRefUrl && refUrl.pathname === '/results') {
        const searchParams = new URLSearchParams();

        RESULTS_REF_URL_PARAMS.forEach((key) => {
            const value = refUrl.searchParams.get(key);
            if (value !== null) searchParams.set(key, value);
        });

        refUrl.search = searchParams.toString();
    }

    const loginParams = new URLSearchParams({ ref_url: refUrl.toString() });
    return addUtmDataToUrl(`${baseLoginUrl}?${loginParams.toString()}`);
}
